import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { flow, isNil, property } from 'lodash';
import { connect } from 'react-redux';
import {
  startDeleteRequest as deleteBankCardStartRequest,
  startFetchRequest as getBankCardsStartRequest,
  startSetDefaultRequest as setDefaultBankCardStartRequest,
} from '../../redux/bankCards/actions';
import BankCards from './BankCards';

const mapStateToProps = createStructuredSelector({
  bankCards: property('payment.bankCards.data'),
  isCardProcessing: property('payment.bankCards.isCardProcessing'),
  isError: flow(property('payment.bankCards.error'), (error) => !isNil(error)),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getBankCards: getBankCardsStartRequest,
      deleteBankCard: deleteBankCardStartRequest,
      setDefaultBankCard: setDefaultBankCardStartRequest,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(BankCards);
